/**
 * Unit-type vocabulary (BCRT-aligned per the Booking.com Rooms API), plus the
 * two property enums that feed `pgEnum()` in `packages/db`.
 *
 * Plain data with no validation, kept out of `enums.ts` because the public
 * Places page names a unit type on a guest's first paint and `enums.ts` reaches
 * classic zod; see test/guest-client-zod.test.ts for what that costs.
 */

export interface UnitType {
  bedrooms: number;
  capacity: number;
  id: string;
  name: string;
}

export const UNIT_TYPES = [
  { bedrooms: 1, capacity: 1, id: "single", name: "Single" },
  { bedrooms: 1, capacity: 2, id: "double", name: "Double" },
  { bedrooms: 1, capacity: 2, id: "twin", name: "Twin" },
  { bedrooms: 1, capacity: 3, id: "triple", name: "Triple" },
  { bedrooms: 1, capacity: 4, id: "quadruple", name: "Quadruple" },
  { bedrooms: 1, capacity: 2, id: "studio", name: "Studio" },
  { bedrooms: 1, capacity: 4, id: "suite", name: "Suite" },
  { bedrooms: 1, capacity: 4, id: "apartment", name: "Apartment" },
  { bedrooms: 2, capacity: 5, id: "family", name: "Family" },
  { bedrooms: 2, capacity: 6, id: "villa", name: "Villa" },
] as const satisfies readonly UnitType[];

export const SIZE_UNITS = ["sqm", "sqft"] as const;

export const SMOKING_POLICIES = ["non_smoking", "smoking", "both"] as const;

export function getUnitTypeById(id: string) {
  return UNIT_TYPES.find((t) => t.id === id);
}
